import React, { useState, useCallback, useEffect } from 'react';
import Form, {
  Item,
  Label,
  ButtonItem,
  ButtonOptions,
  RequiredRule,
} from 'devextreme-react/form';
import './login-admin-form.scss';
import { observer } from 'mobx-react';
import { AuthStore } from '../../common/store';
import { useCookies } from 'react-cookie';
import moment from 'moment';
import { useHistory } from 'react-router-dom';
import CusEntInfoStore from '../../main/corp-info/corp-info-store';
import CusEntInsertPopupContainer from '../../main/corp-info/cusEnt-insert-popup-container';


const idEditorOptions = {
  stylingMode: 'filled',
  placeholder: '아이디',
  mode: 'id',
};

// const emailEditorOptions = { stylingMode: 'filled', placeholder: 'Email', mode: 'email' };

const passwordEditorOptions = {
  stylingMode: 'filled',
  placeholder: '비밀번호',
  mode: 'password',
};

const rememberMeEditorOptions = {
  text: '아이디 저장',
  elementAttr: { class: 'form-text' },
};

const LoginAdminForm = ({companyCode}) => {
  //console.log('LoginForm Load');

  const { error } = AuthStore;
  const [notifyMsg, setNotifyMsg] = useState();

  const [loginAdminInfo, setLoginAdminInfo] = useState({
    adminId: '',
    adminPassword: '',
    adminSaveId: false,
    adminCompanyCode: companyCode == '' ? '' : companyCode,
  });

  /*====== Cookie 관련 선언======*/
   const [cookies, setCookie, removeCookie] = useCookies(["rememberUserId"]); 

   const history = useHistory();

  useEffect(() => {
    if (cookies.rememberAdminUserId !== undefined) {
      const cookieAdminUserId = cookies.rememberAdminUserId;
      setLoginAdminInfo({adminId: cookieAdminUserId, adminPassword: '', adminSaveId: true, adminCompanyCode: companyCode})
    }
  }, [error]);

  const onChange = useCallback((e) => {
    const { dataField, value } = e;

    setLoginAdminInfo((loginAdminInfo) => ({
      ...loginAdminInfo,
      [dataField]: value,
    }));
  }, []);

  const onSubmit = useCallback(
    async (e) => {
      const result = await AuthStore.loginAdmin(loginAdminInfo.adminId, loginAdminInfo.adminPassword, loginAdminInfo.adminSaveId, loginAdminInfo.adminCompanyCode);
      
      if (result.error) {
        CusEntInfoStore.setVisibleCusEntInsertPopup(true);
      } else {
        setNotifyMsg(result.message);
      }

      // 아이디 쿠키 저장
      if (loginAdminInfo.adminSaveId) {
        const expires =  moment().add('1','y').toDate()
        setCookie("rememberAdminUserId", loginAdminInfo.adminId, {expires});
      } else {
        removeCookie("rememberAdminUserId");
      }
    },
    [loginAdminInfo]
  );

  return (
    <React.Fragment>
    <form className={'login-admin-form'}>
      <Form
        formData={loginAdminInfo}
        onFieldDataChanged={onChange}
      >
        <Item
          dataField={'adminId'}
          editorType={'dxTextBox'}
          editorOptions={idEditorOptions}
        >
          <RequiredRule message="아이디를 입력하세요" />
          <Label visible={false} />
        </Item>
        <Item
          dataField={'adminPassword'}
          editorType={'dxTextBox'}
          editorOptions={passwordEditorOptions}
        >
          <RequiredRule message="비밀번호를 입력하세요" />
          <Label visible={false} />
        </Item>
        <Item
          dataField={'adminSaveId'}
          editorType={'dxCheckBox'}
          editorOptions={rememberMeEditorOptions}
        >
          <Label visible={false} />
        </Item>
        <ButtonItem>
          <ButtonOptions
            width={'100%'}
            height={'50px'}
            type={'default'}
            onClick={onSubmit}
          >
            <span className="dx-button-text" style={{ fontSize: '20px' }}>
              {
                '로그인'
              }
            </span>
          </ButtonOptions>
        </ButtonItem>
        {/* <ButtonItem>
          <ButtonOptions
            width={'100%'}
            type={'default'}
            onClick={createAccount}
          >
            <span className="dx-button-text">
              {loading ? (
                <LoadIndicator width={'24px'} height={'24px'} visible={true} />
              ) : (
                '계정생성'
              )}
            </span>
          </ButtonOptions>
        </ButtonItem> */}
        <Item>
            <span className="notify-error"> {notifyMsg} </span>
        </Item>
      </Form>
      <CusEntInsertPopupContainer/>
    </form>
    </React.Fragment>
  );
};

export default React.memo(observer(LoginAdminForm));
